import {
  useWorkspaceSection,
  WorkspaceSection,
} from "../../../view_stores/useDashboardControlsStore";
import ProjectExport from "../../project_export/ProjectExport";
import ProjectIcon from "../../project_icon/ProjectIcon";
import ProjectPublish from "../../project_publish/ProjectPublish";
import ProjectSettings from "../../project_settings/ProjectSettings";
import { ProjectFilesLazy } from "../../projectFiles/ProjectFilesLazy";
import { ProjectDebug } from "./ProjectDebug";

export function ProjectWorkspaceContent() {
  const workspaceSection = useWorkspaceSection();

  const content = () => {
    switch (workspaceSection) {
      // case WorkspaceSection.OVERVIEW:
      // return <ProjectOverview />;
      case WorkspaceSection.ICON:
        return <ProjectIcon />;
      case WorkspaceSection.CODE:
        return <ProjectFilesLazy />;
      case WorkspaceSection.DEBUG:
        return <ProjectDebug />;
      case WorkspaceSection.PUBLISH:
        return <ProjectPublish />;
      case WorkspaceSection.EXPORT:
        return <ProjectExport />;
      case WorkspaceSection.SETTINGS:
        return <ProjectSettings />;
      default:
        return (
          <div
            className="flex items-center justify-center h-full
          text-dark-text"
          >
            Coming soon...
          </div>
        );
    }
  };

  return <div className="w-full h-full overflow-hidden">{content()}</div>;
}
